import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';

import { BackButton } from 'components/ui';
import {
  CloseCross,
  PrimaryButton,
  Heading_1 as Heading1,
  Body_2 as Body2
} from '@huggg/react-components';
import Dialog from './Dialog';
import styles from './confirmation-dialog.module.scss';
import dictionary from 'config/dictionary.json';

import Switch from 'react-switch';

class ConfirmationDialog extends Component {
  state = {
    hasToggledConfirm: false
  };

  constructor() {
    super();
    this.modalRef = createRef();

    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.onConfirmClick = this.onConfirmClick.bind(this);
    this.onCancelClick = this.onCancelClick.bind(this);
    this.onToggleConfirm = this.onToggleConfirm.bind(this);
  }

  open() {
    this.modalRef.current && this.modalRef.current.open();
  }

  close() {
    this.modalRef.current && this.modalRef.current.close();
  }

  onConfirmClick(event) {
    const { onConfirm } = this.props;

    event && event.preventDefault();
    onConfirm && onConfirm();
  }

  onCancelClick(event) {
    const { onCancel } = this.props;

    event && event.preventDefault();

    onCancel && onCancel();
  }

  onToggleConfirm(hasToggledConfirm) {
    this.setState({
      ...this.state,
      hasToggledConfirm
    });
  }

  renderContent() {
    const { huggg, segment, nestedSegmentSelected } = this.props;

    const { redesign: copy } = dictionary.confirmationDialog;

    return (
      <Body2>
        <div className={styles.header}>
          <Heading1 className={styles.confirmationTitle}>
            {'Are you sure?'}
          </Heading1>
          <div className={styles['close-cross']}>
            <CloseCross onClick={this.onCancelClick} />
          </div>
        </div>

        <p className={styles.lede}>{copy.lede}</p>

        <img
          src={
            segment.images?.length
              ? segment.images[0]
              : huggg.purchase.image_url
          }
          alt={segment.name}
          className={styles['image-img']}
        />
        <h2 className={styles.segmentTitle}>{segment.name}</h2>

        {!nestedSegmentSelected ? (
          <>
            <span className={styles.declaration}>
              <Switch
                onChange={this.onToggleConfirm}
                checked={this.state.hasToggledConfirm}
                height={16}
                width={28}
            onColor="#4dc44d"
          />
          <span className={styles.declarationText}>{copy.declaration}</span>
        </span>
        <div className={styles.warning}>
            <span>{copy.warning}</span>
          </div>
        </>
      ) : null}
    </Body2>
    );
  }
  renderButtons() {
    const { confirmButtonText, nestedSegmentSelected } = this.props;

    const { hasToggledConfirm } = this.state;

    return (
      <div className={styles.buttons}>
        <PrimaryButton
          className={styles.confirm}
          onClick={this.onConfirmClick}
          data-test-id="confirmation-dialog-confirm"
          disabled={!nestedSegmentSelected && !hasToggledConfirm}
          label={confirmButtonText?.toUpperCase()}
        />
        <BackButton onClick={this.onCancelClick} />
      </div>
    );
  }

  render() {
    const {
      header,
      body,
      confirmButtonText,
      cancelButtonText,
      onCancel,
      onConfirm,
      huggg,
      segment,
      nestedSegmentSelected,
      ...rest
    } = this.props;

    return (
      <Dialog
        disableOverlayClick={true}
        ref={this.modalRef}
        contentClassName={styles['content-redesign']}
        showCloseButton={false}
        {...rest}
      >
        {this.renderContent()}
        {this.renderButtons()}
      </Dialog>
    );
  }
}

ConfirmationDialog.defaultProps = {
  confirmButtonText: dictionary.confirmationDialog.defaultConfirmButton,
  cancelButtonText: dictionary.confirmationDialog.defaultCancelButton
};

ConfirmationDialog.propTypes = {
  cancelButtonText: PropTypes.string.isRequired,
  confirmButtonText: PropTypes.string.isRequired,
  body: PropTypes.node,
  header: PropTypes.node,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
  huggg: PropTypes.object.isRequired,
  segment: PropTypes.object.isRequired,
  nestedSegmentSelected: PropTypes.bool
};

export default ConfirmationDialog;
